import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41ca2d41")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OAutoComplete = _resolveComponent("OAutoComplete")

  return (_openBlock(), _createBlock(_component_OAutoComplete, {
    ref: "autoComplete",
    modelValue: _ctx.modelValueComputed,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValueComputed = $event)),
    class: "select-fish",
    "force-selection": "",
    suggestions: _ctx.fishes,
    placeholder: _ctx.placeholder,
    field: "name",
    disabled: _ctx.loading,
    onComplete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchFish($event)))
  }, {
    item: _withId((slotProps) => [
      _createVNode("div", {
        class: [
          'select-fish__text',
          { 'select-fish__text--inactive': slotProps.item.inactive },
        ]
      }, _toDisplayString(slotProps.item.name), 3)
    ]),
    _: 1
  }, 8, ["modelValue", "suggestions", "placeholder", "disabled"]))
})